<template>
    <div :id="id"
         class="modal"
         tabindex="-1"
         role="dialog"
         :aria-labelledby="id + '-label'"
         aria-hidden="true">
        <div :class="['modal-dialog', size, centered]" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="id + '-label'">
                        {{ title }}
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModalComponent",
        computed: {
            centered() {
                return {
                    'modal-dialog-centered': this.$props.center
                }
            }
        },
        props: {
            id: {
                type: [String, Number],
                default: '',
                required: true
            },
            title: {
                type: String,
                default: '',
                required: true
            },
            size: {
                type: String,
                default: '',
                required: false,
                validator: value => {
                    return ['modal-lg', 'modal-sm', ''].indexOf(value) !== -1
                }
            },
            center: {
                type: Boolean,
                default: false,
                required: false
            }
        }
    }
</script>

<style scoped>

</style>